import { z } from 'zod';

import { unique } from '@vestigas/utils';

export const zodDeliveryNoteChainsAdminPayloadSchema = z.object({
  ids: z.tuple([z.uuid()], z.uuid()).transform((ids) => unique(ids).toSorted()),
});
